import * as uuid from "uuid";

/**
 * Generates random-based UUID V4.
 */
export const generateUuid = () => {
  return uuid.v4();
};
